<app-language-button position="right" class="right-btn"></app-language-button>

<router-outlet></router-outlet>

<app-footer></app-footer>
